/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {COMPILER_PROVIDERS as Éµangular_packages_platform_browser_dynamic_testing_testing_a,TestingCompilerFactoryImpl as Éµangular_packages_platform_browser_dynamic_testing_testing_b} from './src/compiler_factory';